import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['digit', 'hidden', 'submit']

  connect() {
    this.updateHidden()
  }

  onInput(event) {
    const input = event.target
    const value = input.value.replace(/\D/g, '')
    input.value = value.slice(0, 1)

    if (value.length > 0) {
      const index = this.digitTargets.indexOf(input)
      if (index < this.digitTargets.length - 1) {
        this.digitTargets[index + 1].focus()
      }
    }

    this.updateHidden()
  }

  onKeydown(event) {
    const input = event.target
    const index = this.digitTargets.indexOf(input)

    if (event.key === 'Backspace' && input.value === '' && index > 0) {
      this.digitTargets[index - 1].focus()
      this.digitTargets[index - 1].value = ''
      this.updateHidden()
    }
  }

  onPaste(event) {
    event.preventDefault()
    const paste = (event.clipboardData || window.clipboardData).getData('text')
    const digits = paste.replace(/\D/g, '').slice(0, this.digitTargets.length).split('')

    digits.forEach((digit, i) => {
      if (this.digitTargets[i]) {
        this.digitTargets[i].value = digit
      }
    })

    const focusIndex = Math.min(digits.length, this.digitTargets.length - 1)
    this.digitTargets[focusIndex].focus()
    this.updateHidden()
  }

  updateHidden() {
    const code = this.digitTargets.map((input) => input.value).join('')
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = code
    }
  }
}
